import {
  IconAnalytics,
  IconAtom,
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconChainLink,
  IconChainLinkGray,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconChartRadiusGray,
  IconClockGray,
  IconCloudCheckGray,
  IconCoil,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconPenSquare,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconTagGray,
  IconTvocGray,
  IconUserCheck,
  IconWarning,
  IconWarningGray,
  IconZoneGray,
} from '@assets/images/icon';
import { IconTemp } from '@assets/images/main';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/manufacturingProcess/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/manufacturingAsset/img/1.avif';
import image2 from '@src/assets/images/solution/manufacturingAsset/img/2.avif';
import image3 from '@src/assets/images/solution/manufacturingAsset/img/3.avif';
import image4 from '@src/assets/images/solution/manufacturingAsset/img/4.avif';
import image5 from '@src/assets/images/solution/manufacturingAsset/img/5.avif';
import image6 from '@src/assets/images/solution/manufacturingAsset/img/6.avif';
import image7 from '@src/assets/images/solution/manufacturingAsset/img/7.avif';
import image8 from '@src/assets/images/solution/manufacturingAsset/img/8.avif';

export default {
  type: '제조 솔루션',
  banner: {
    title: '대형 물류 창고의 재고 자산을 AI로 효율적이고 정확하게 관리하세요.',
    desc: 'AI 영상 인식 기술을 활용해 철강코일을 비롯한 다양한 물류 자산을 자동으로 파악하여 정확하고 효율적으로 재고를 관리합니다.',
  },

  video: {
    title: '복잡한 물류 환경에서도 AI를 통해 실시간으로 재고 자산 현황을 관리하세요.',
    desc: '기존 수작업 카운팅 방식은 복잡한 물류 환경에서 효율적이지 않고 오류가 잦았습니다. ORBRO의 AI 시스템은 철강코일과 같은 다양한 물류 자산을 자동으로 식별하고 정확하게 관리하여, 창고 운영의 효율성을 높입니다.',
    // play: video,
    image: image1,
  },

  func: [
    {
      theme: 'AI 영상 분석 기술로 다양한 물류 자산을 정확히 관리합니다.',
      title: 'AI 영상 기반 자산 자동 카운팅',
      desc: '철강코일을 비롯해 다양한 물류 자산을 AI 카메라가 실시간으로 정확히 인식하여 자동으로 재고를 카운팅합니다. 복잡한 창고에서도 신속하고 정확한 재고 관리가 가능합니다.',
      sub1: '실시간 현황 파악',
      icon1: IconClockGray,
      sub2: '통계 데이터 제공',
      icon2: IconChartBarGray,
      image: image2,
    },
    {
      title: '철강코일과 팔레트 AI 인식 및 관리',
      desc: '철강코일과 이를 운반하는 팔레트까지 AI 영상 기술로 정확하게 동시에 인식하여 복합 자산의 재고 관리가 가능합니다. 서로 다른 형태의 자산이 혼재된 상황에서도 효율적으로 재고 현황을 관리할 수 있습니다.',
      sub1: '실시간 위치 추적',
      icon1: IconBinocularsGray,
      sub2: '높은 정확도 제공',
      icon2: IconRulerGray,
      image: image3,
    },
    {
      title: '다양한 자산 모델 학습 및 자동 관리 시스템',
      desc: '철강코일과 팔레트를 포함한 다양한 자산 모델을 AI가 학습하고 인식하여, 복합적인 자산의 정확한 관리가 가능합니다.',
      sub1: '위험 자산 지정',
      icon1: IconWarningGray,
      sub2: '대응 방식 설정',
      icon2: IconChartRadiusGray,
      image: image4,
    },
    {
      theme: '자동화된 데이터 분석으로 물류 운영의 효율성을 극대화합니다.',
      title: '구역별 재고 현황 실시간 파악',
      desc: '창고 내 각 구역별 재고 현황을 즉시 확인하여 데이터 기반의 정확한 운영이 가능하며 신속한 의사 결정을 지원합니다.',
      sub1: '데이터 클라우드 저장',
      icon1: IconClockGray,
      sub2: '통계 데이터 제공',
      icon2: IconChartBarGray,
      image: image5,
    },
    {
      title: '시간대별 재고 물류량 변화 추적 및 예측',
      desc: '재고 물류량의 시간대별 변화를 자동으로 기록하고 분석하여, 물류 흐름을 정확히 예측하고 효과적으로 대응할 수 있습니다.',
      sub1: '위험 자산 지정',
      icon1: IconWarningGray,
      sub2: '대응 방식 설정',
      icon2: IconChartRadiusGray,
      image: image6,
    },
    {
      title: '수기 재고관리 자동화',
      desc: 'AI 기반 자동 카운팅을 통해 기존의 수기 재고관리 방식을 자동화하여 수작업으로 인한 오류와 시간 소모를 획기적으로 줄입니다.',
      sub1: '데이터 클라우드 저장',
      icon1: IconClockGray,
      sub2: '통계 데이터 제공',
      icon2: IconChartBarGray,
      image: image7,
    },
    {
      title: '분석 데이터 CSV 파일 추출',
      desc: '분석된 재고 및 물류 데이터를 CSV 파일 형태로 간편하게 추출하여 다양한 업무 보고와 분석에 활용할 수 있습니다.',
      sub1: '데이터 클라우드 저장',
      icon1: IconClockGray,
      sub2: '통계 데이터 제공',
      icon2: IconChartBarGray,
      image: image8,
    },
  ],

  system: {
    title: '시스템 구성',
    img: rtlsSystem,
  },

  productTitle: '제품 구성',
  product: [
    {
      tag: 'assetPackage',
    },
    {
      tag: 'workerPackage',
    },
  ],

  subfunc: {
    title: '주요기능 요약',
    desc: '',

    data: [
      {
        icon: IconAtom, // AI 기반 자동 인식 → Atom: AI 기술/자동 인식 의미 강조
        title: 'AI 기반 자산 자동 인식',
        desc: 'AI 기술로 자산을 실시간으로 자동 인식하여 정확하고 효율적인 관리가 가능합니다.',
      },
      {
        icon: IconCoil, // 철강코일 및 팔레트 인식 → Coil 아이콘 있음!
        title: '철강코일 및 팔레트 인식',
        desc: '철강코일과 팔레트를 동시에 AI로 인식해 복잡한 환경에서도 정확히 재고를 관리합니다.',
      },
      {
        icon: IconLocation, // 자산 위치/상태 모니터링 → Location: 위치 강조
        title: '자산 위치 및 상태 모니터링',
        desc: '물류 창고 내 자산의 위치와 상태를 실시간으로 분석하여 효율적인 관리가 가능합니다.',
      },
      {
        icon: IconPenSquare, // 수기 재고관리 자동화 → PenSquare: 수기/자동화 전환 상징
        title: '수기 재고관리 자동화',
        desc: '기존 수기 방식의 재고 관리를 자동화하여 업무 효율과 정확성을 크게 높입니다.',
      },
      {
        icon: IconDashboard, // 실시간 재고현황 대시보드 → Dashboard 유지
        title: '실시간 재고현황 대시보드',
        desc: '창고 내 자산 현황을 한눈에 파악할 수 있는 실시간 대시보드를 제공합니다.',
      },
      {
        icon: IconRoute, // 자산 이동경로 분석 → Route 유지 (경로)
        title: '자산 이동경로 분석',
        desc: 'AI 기반으로 자산의 이동 경로와 사용 패턴을 분석해 효율적인 운영 계획 수립을 돕습니다.',
      },
      {
        icon: IconLayers, // 구역별 재고 실시간 관리 → Layers: 구역/층 구조 상징
        title: '구역별 재고 실시간 관리',
        desc: '각 구역의 자산 보유 상태를 실시간으로 확인하여 정확하고 효율적으로 관리합니다.',
      },
      {
        icon: IconChartBar, // 시간대별 재고 변동 분석 → ChartBar: 분석/그래프
        title: '시간대별 재고 변동 분석',
        desc: '재고 변화를 시간대별로 분석하여 물류 흐름을 예측하고 빠른 대응이 가능합니다.',
      },
      {
        icon: IconSecurity, // AI의 높은 인식률 → Security 유지 (정확성/신뢰)
        title: 'AI의 높은 인식률',
        desc: '다양한 자산을 AI가 99% 이상 정확도로 인식하여 신뢰도 높은 데이터를 제공합니다.',
      },
      {
        icon: IconAnalytics, // 운영 데이터 기반 의사결정 지원 → Analytics: 의사결정/분석
        title: '운영 데이터 기반 의사결정 지원',
        desc: '분석된 운영 데이터를 기반으로 빠르고 정확한 의사결정과 전략 수립을 지원합니다.',
      },
    ],
  },

  contents: [
    {
      data: 'manufacturingAsset',
    },
    {
      data: 'logisticsAsset',
    },
    {
      data: 'blogMedical',
    },
    {
      data: 'blogRTLS',
    },
  ],
};
